/**
 * Bindet Click-Events an alle Elemente mit dem Attribut 'data-tracking'.
 * @param {HTMLElement} $content - Der Container, in dem gesucht werden soll.
 */
const bindTrackingClick = ($content) => {
    const $trackingElements = $content.querySelectorAll('[data-tracking]');

    $trackingElements.forEach(($trackingElement) => {
        $trackingElement.addEventListener('click', () => {
            // Beispiel Markup:
            // <button data-tracking="content_teaser|click|link">track me</button>
            const trackingData = getTrackingData($trackingElement);

            if (trackingData) {
                sendTracking(trackingData);
            }
        });
    });
};

/**
 * Extrahiert die Tracking-Daten aus dem Data-Attribut.
 * Erwartetes Format: "Kategorie|Aktion|Label|Wert"
 * @param {HTMLElement} $trackingElement
 * @returns {Object} Das Tracking-Daten Objekt
 */
const getTrackingData = ($trackingElement) => {
    const trackingString = $trackingElement.getAttribute('data-tracking');

    // Sicherheitscheck, falls Attribut leer ist
    if (!trackingString) return false;

    const trackingArray = trackingString.split('|');

    return {
        category: trackingArray[0],
        action: trackingArray[1],
        label: trackingArray[2],
        value: trackingArray[3] // ist undefined, wenn nicht vorhanden
    };
};

/**
 * Sendet die Daten an den Google Tag Manager (Data Layer).
 * @param {Object} data - Enthält category, action, label, (value)
 */
const sendTracking = (data) => {
    window.dataLayer = window.dataLayer || [];

    const trackingPayload = {
        event: 'custom_tracking_event',
        eventCategory: data.category,
        eventAction: data.action,
        eventLabel: data.label
    };

    if (data.value !== undefined) {
        trackingPayload.eventValue = data.value;
    }

    window.dataLayer.push(trackingPayload);

    console.log('GTM Tracking Push:', trackingPayload);
};

export {
    bindTrackingClick,
    sendTracking,
    getTrackingData
};
